import styled from 'styled-components'

export const LoginStyled = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`
export const FormStyled = styled('form')`
  width: 100%;
  max-width: 300px;
`

export const LoginError = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.pastelRed};
  margin: 20px auto;
  text-align: center;
`
